import type { Message } from "@ai-sdk/react"
import { TokenService } from "./TokenService"
import { SessionService } from "./SessionService"

const API_URL = import.meta.env.VITE_API_URL;

export interface ChatRequestBody {
  messages: { role: string; content: string }[]
  provider: string
  docset_id: string
  user_id: string
  session_id: string
}

export class ChatApiService {
  static prepareRequestBody(
    messages: Message[], 
    provider: string, 
    docset: string
  ): ChatRequestBody {
    return {
      messages: messages.map(({ role, content }) => ({ role, content })),
      provider,
      docset_id: docset,
      user_id: SessionService.getUserId(),
      session_id: SessionService.getSessionId(),
    };
  }

  static getApiUrl(): string {
    return `${API_URL}/api/chat`;
  }



  static prepareHeaders(provider: string): Record<string, string> {
    const authHeaders = TokenService.getAuthHeaders(provider);
    const sessionId = SessionService.getSessionId();
    
    // Add X-Session-ID header directly when preparing headers for API request
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...authHeaders
    };
    
    // Add Session ID if exists
    if (sessionId) {
      headers['X-Session-ID'] = sessionId;
      console.log("Adding session ID to header:", sessionId);
    } else {
      console.warn("Session ID not found, couldn't add to header!");
    }
    
    return headers;
  }

  static getChatConfig(provider: string, docset: string) {
    // Create headers with current session ID each time
    const sessionId = SessionService.getSessionId();
    console.log("Current session ID for chat config:", sessionId);
    
    return {
      api: this.getApiUrl(),
      experimental_prepareRequestBody: ({ messages }: { messages: Message[] }) => 
        this.prepareRequestBody(messages, provider, docset),
      headers: this.prepareHeaders(provider)
    };
  }
} 